"use strict";var p=Object.defineProperty;var d=Object.getOwnPropertyDescriptor;var r=(h,n,t,s)=>{for(var i=s>1?void 0:s?d(n,t):n,e=h.length-1,l;e>=0;e--)(l=h[e])&&(i=(s?l(n,t,i):l(i))||i);return s&&i&&p(n,t,i),i};import{baseStyles as v,CiscoUElement as m,html as a,nothing as c}from"@cisco-u/base";import"@cisco-u/navigation-buttons/cu-navigation-buttons.js";import{property as u,state as o}from"@cisco-u/base/src/decorators.js";import{classMap as _}from"@cisco-u/base/src/directives.js";import b from"./pagination.css.js";export class Pagination extends m{constructor(){super(...arguments);this.total=1;this.current=1;this.dark=!1;this.carousel=!1;this._underRestriction=!0;this._numListRestrict=7;this._pageJumpAmount=3;this._activePage=1;this._startPageActive=!1;this._centerPageActive=!1;this._endPageActive=!1;this._currentViewport=window.innerWidth;this._mobileView=!1}connectedCallback(){super.connectedCallback();const t=()=>{this._currentViewport=window.innerWidth},s=this._throttle(t,50);window.onresize=()=>{s()}}static get styles(){return[v,b]}render(){const t=this._setClasses();return a`
      <div class=${_({...t})} role="navigation">
        <div>
          <cu-navigation-buttons
            type="prev"
            size="small"
            class=${this.current===1?"disabled":c}
            .disabled=${this.current===1}
            @click=${s=>this._dispatchPage(this.current-1,s)}
            dark=${this.dark?!0:c}
            showText=${this._mobileView?!0:c}
            carousel=${this.carousel?!0:c}
          ></cu-navigation-buttons>
        </div>

        <div class=${this._mobileView?"hide":c}>
          ${this._loadPageList()}
        </div>

        <div>
          <cu-navigation-buttons
            type="next"
            size="small"
            class=${this.current===this.total?"disabled":c}
            .disabled=${this.current===this.total}
            @click=${s=>this._dispatchPage(this.current+1,s)}
            dark=${this.dark?!0:c}
            showText=${this._mobileView?!0:c}
            carousel=${this.carousel?!0:c}
          ></cu-navigation-buttons>
        </div>
      </div>
    `}willUpdate(){this._underRestriction=this.total<=this._numListRestrict,this._startPageActive=this.current<5,this._centerPageActive=this.current>=5&&this.current<=this.total-4,this._endPageActive=this.current>this.total-4,this._mobileView=this.total<=5&&this._currentViewport<672}_dispatchPage(t,s){s.preventDefault(),t>=1&&t<=this.total&&(this.current=t,this.dispatchEvent(new CustomEvent("page-num",{detail:{pageNum:t}})))}_numLoop(){let t=1,s=1;const i=[];this._underRestriction?t=this.total:(this._startPageActive&&(t=5),this._centerPageActive&&(t=this.current+1,s=this.current-1),this._endPageActive&&(t=this.total,s=this.total-4)),!this._underRestriction&&!this._startPageActive&&(i.push(a`
        <li class="page-num ${this.current===1?"active":""}">
          <button
            @click=${e=>this._dispatchPage(1,e)}
            aria-label="Page 1"
          >
            ${this.carousel?a`<span class="icon-circle">1</span>`:"1"}
          </button>
        </li>
      `),i.push(a`
        <li class="page-overflow">
          <button
            @click=${e=>this._dispatchPage((this.current<this.total-3?this.current:this.total-3)-this._pageJumpAmount,e)}
            aria-label="Previous Page Group"
          >
            ${this.carousel?a`<span class="icon-circle">...</span>`:a`...`}
          </button>
        </li>
      `));for(let e=s;e<=t;e++)i.push(a`
        <li class="page-num ${this.current===e?"active":""}">
          <button
            @click=${l=>this._dispatchPage(e,l)}
            aria-label="Page ${e}"
          >
            ${this.carousel?a`<span class="icon-circle">${e}</span>`:e}
          </button>
        </li>
      `);return!this._underRestriction&&!this._endPageActive&&(i.push(a`
        <li class="page-overflow">
          <button
            @click=${e=>this._dispatchPage((this.current>4?this.current:4)+this._pageJumpAmount,e)}
            aria-label="Next Page Group"
          >
            ${this.carousel?a`<span class="icon-circle">...</span>`:a`...`}
          </button>
        </li>
      `),i.push(a`
        <li class="page-num ${this.current===this.total?"active":""}">
          <button
            @click=${e=>this._dispatchPage(this.total,e)}
            aria-label="Page ${this.total}"
          >
            ${this.carousel?a`<span class="icon-circle">${this.total}</span>`:this.total}
          </button>
        </li>
      `)),i}_loadPageList(){return a`
      <ul class="page-list">
        ${this._numLoop()}
      </ul>
    `}_throttle(t,s){let i,e,l;return function(){i?(clearTimeout(e),e=setTimeout(()=>{Date.now()-l>=s&&(t.apply(this),l=Date.now())},Math.max(s-(Date.now()-l),0))):(t.apply(this),l=Date.now(),i=!0)}}_setClasses(){return{"pagination-wrap":!0,dark:this.dark,"justify-between":this._mobileView,carousel:this.carousel}}}r([u({type:Number,reflect:!0})],Pagination.prototype,"total",2),r([u({type:Number,reflect:!0})],Pagination.prototype,"current",2),r([u({type:Boolean,reflect:!0})],Pagination.prototype,"dark",2),r([u({type:Object,reflect:!0})],Pagination.prototype,"carousel",2),r([o()],Pagination.prototype,"_underRestriction",2),r([o()],Pagination.prototype,"_numListRestrict",2),r([o()],Pagination.prototype,"_pageJumpAmount",2),r([o()],Pagination.prototype,"_activePage",2),r([o()],Pagination.prototype,"_startPageActive",2),r([o()],Pagination.prototype,"_centerPageActive",2),r([o()],Pagination.prototype,"_endPageActive",2),r([o()],Pagination.prototype,"_currentViewport",2),r([o()],Pagination.prototype,"_mobileView",2);
//# sourceMappingURL=Pagination.js.map
